import { Store } from '@/store/store.class'

interface UIState extends Object {
    route: {
      settingsDrawer: boolean;
    };
    nav: {
      open: boolean;
    };
}

class UIStore extends Store<UIState> {
  constructor() {
    super({
      name: 'ui',
      cached: false,
      state: {
        nav: {
          open: false
        },
        route: {
          settingsDrawer: false
        }
      }
    })
  }

  toggleNav(force?: boolean) {
    this.mutate(state => state.nav.open = force !== undefined ? force : !state.nav.open)
  }

}
export const uiStore = new UIStore()